/**
 * OMNIVASO i18n Module — Chinese Simplified (zh)
 * Hand-curated. All keys must mirror en.js exactly.
 * Locale: zh-CN  |  hreflang: zh-Hans
 */
const zh = {
    nav: {
        home:            '首页',
        shop:            '商店',
        cart:            '购物车',
        search:          '搜索',
        articles:        '文章',
        blog:            '博客',
        about:           '关于我们',
        contact:         '联系我们',
        account:         '我的账户',
        orders:          '我的订单',
        login:           '登录',
        logout:          '退出登录',
        openMenu:        '打开菜单',
        closeMenu:       '关闭菜单',
        skipToContent:   '跳转到内容',
    },

    actions: {
        readMore:        '阅读更多',
        viewAll:         '查看全部',
        learnMore:       '了解更多',
        back:            '返回',
        close:           '关闭',
        save:            '保存',
        cancel:          '取消',
        submit:          '提交',
        confirm:         '确认',
        delete:          '删除',
        edit:            '编辑',
        add:             '添加',
        remove:          '移除',
        search:          '搜索',
        reset:           '重置',
        next:            '下一步',
        previous:        '上一步',
        loading:         '加载中...',
        tryAgain:        '重试',
        copy:            '复制',
        share:           '分享',
        download:        '下载',
        upload:          '上传',
        apply:           '应用',
        clear:           '清除',
    },

    status: {
        success:         '成功！',
        error:           '发生错误，请重试。',
        saved:           '保存成功。',
        notFound:        '页面未找到。',
        comingSoon:      '即将上线。',
        outOfStock:      '缺货',
        inStock:         '有货',
        soldOut:         '已售罄',
        new:             '新品',
        sale:            '促销',
        featured:        '精选',
        noResults:       '未找到结果。',
        required:        '此字段为必填项。',
        invalidEmail:    '请输入有效的电子邮件地址。',
    },

    shop: {
        addToCart:       '加入购物车',
        addedToCart:     '已加入购物车',
        viewCart:        '查看购物车',
        checkout:        '结账',
        continueShopping:'继续购物',
        orderSummary:    '订单摘要',
        orderTotal:      '订单总额',
        subtotal:        '小计',
        shipping:        '运费',
        tax:             '税费',
        discount:        '折扣',
        couponCode:      '优惠码',
        applyCoupon:     '使用优惠码',
        quantity:        '数量',
        price:           '价格',
        total:           '合计',
        remove:          '移除',
        emptyCart:       '您的购物车是空的。',
        browseProducts:  '浏览商品',
        product:         '商品',
        products:        '商品',
        category:        '分类',
        categories:      '分类',
        sortBy:          '排序方式',
        filterBy:        '筛选方式',
        allProducts:     '全部商品',
        searchProducts:  '搜索商品...',
        productDetails:  '商品详情',
        relatedProducts: '相关商品',
        stockLeft:       '件库存剩余',
        freeShipping:    '免费配送',
        placeOrder:      '提交订单',
        orderConfirmed:  '订单已确认！',
        trackOrder:      '追踪订单',
        orderNumber:     '订单号',
        paymentMethod:   '支付方式',
        billingAddress:  '账单地址',
        shippingAddress: '配送地址',
        firstName:       '名字',
        lastName:        '姓氏',
        email:           '电子邮件',
        phone:           '电话号码',
        address:         '地址',
        city:            '城市',
        province:        '省份 / 州',
        postalCode:      '邮政编码',
        country:         '国家',
        secureCheckout:  '安全结账',
        payWith:         '使用以下方式支付',
    },

    articles: {
        by:              '作者：',
        publishedOn:     '发布于',
        minuteRead:      '分钟阅读',
        tags:            '标签',
        share:           '分享这篇文章',
        relatedArticles: '相关文章',
        allArticles:     '全部文章',
        noArticles:      '未找到文章。',
        searchArticles:  '搜索文章...',
    },

    search: {
        placeholder:     '搜索商品、文章、页面...',
        results:         '搜索结果',
        noResults:       '未找到相关结果：',
        searching:       '搜索中...',
        searchTip:       '按 ⌘K 或 Ctrl+K 搜索',
        quickSearch:     '快速搜索',
    },

    newsletter: {
        subscribe:       '订阅',
        subscribeTitle:  '保持关注',
        subscribeDesc:   '将最新动态直接发送到您的收件箱。',
        emailPlaceholder:'请输入您的邮箱',
        thankYou:        '感谢您的订阅！',
        alreadySubscribed:'您已订阅。',
        privacyNote:     '我们尊重您的隐私，您可随时取消订阅。',
    },

    footer: {
        rights:          '版权所有。',
        privacy:         '隐私政策',
        terms:           '使用条款',
        sitemap:         '网站地图',
        poweredBy:       '技术支持：',
        contactUs:       '联系我们',
        followUs:        '关注我们',
        quickLinks:      '快速链接',
    },

    forms: {
        email:           '电子邮件',
        password:        '密码',
        confirmPassword: '确认密码',
        username:        '用户名',
        name:            '姓名',
        message:         '留言',
        subject:         '主题',
        send:            '发送',
        sending:         '发送中...',
        sent:            '消息已发送！',
        signIn:          '登录',
        signUp:          '注册',
        forgotPassword:  '忘记密码？',
        rememberMe:      '记住我',
        changePassword:  '修改密码',
        currentPassword: '当前密码',
        newPassword:     '新密码',
    },

    i18n: {
        selectLanguage:  '选择语言',
        language:        '语言',
    },

    errors: {
        pageNotFound:    '页面未找到',
        pageNotFoundDesc:'您访问的页面不存在或已被移动。',
        goHome:          '返回首页',
        somethingWrong:  '发生了错误',
        somethingWrongDesc: '发生了意外错误，您的数据是安全的。',
        returnToStorefront: '返回商店',
    },
};

export default zh;
